import styled from '@emotion/styled'

export const StyledItems = styled.div`


    display: flex;
    flex-direction: column;
    gap: 40px;

`